import React from 'react';
import Paper from 'material-ui/Paper';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import PinDropIcon from 'material-ui/svg-icons/maps/pin-drop';
import './RetailerSearch.css';

const styles = {
  hintStyle: {
    fontSize: 24,
    width: "100%",
    textAlign: "center",
  },
  inputStyle: {
    fontSize: 24,
    textAlign: "center",
  },
  iconStyle: {
    fontSize: 44,
    color: "#689F38",
    width: 44,
    height: 44,
  },
};

class RetailerSearch extends React.Component {
  state = {
    zipcode: "",
    error: "",
  }

  handleChange = (e) => {
    this.setState({
      zipcode: e.target.value,
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();

    // validate the input
    var zipreg = /^\d{5}$/i;
    if (!this.state.zipcode.match(zipreg)){
      this.setState({
        error: "Please enter a 5 digit Zip Code",
      });
      return false;
    }
    this.props.searchFunc(this.context.router, this.state.zipcode)
  }

  render() {
    return (
      <Paper zDepth={1} rounded={false} className="form-panel">
        <div className="form-header">
          <PinDropIcon style={styles.iconStyle}/>
          <div><h4>Find a store near you</h4></div>
          <div><h6 className="form-subheading">Enter Zip Code</h6></div>
        </div>
        <form onSubmit={this.handleSubmit}>
          <TextField 
            value={this.state.zipcode}
            onChange={this.handleChange}
            fullWidth={true}
            rows={1}
            errorText={this.state.error}
            inputStyle={styles.inputStyle}
            hintText={this.props.defaultZip}
            hintStyle={styles.hintStyle} />
          <RaisedButton primary={true} buttonStyle={styles.buttonStyle} label="Find Nearest Store" fullWidth={true} onTouchTap={this.handleSubmit}/>
        </form>
        <h6><span className="primary-color">FREE*</span> Same Day Delivery or Curbside Pickup</h6>
      </Paper>
    );
  }
}

RetailerSearch.defaultProps = {
  defaultZip: '01742'
}

RetailerSearch.propTypes = {
  defaultZip: React.PropTypes.string,
  searchFunc: React.PropTypes.func.isRequired,
}

RetailerSearch.contextTypes = {
  router: React.PropTypes.object
};

export default RetailerSearch



// WEBPACK FOOTER //
// ./src/components/rsearch/RetailerSearch.js